import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadNodes, NodeSnapshot, nodeIsStale } from './node-monitor';
import styles from './NodeMonitorPage.module.css';

export default function NodeMonitorAlerts() {
  const [snapshot, setSnapshot] = useState<NodeSnapshot | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    let busy = false;
    const load = async () => {
      if (busy) return;
      busy = true;
      try { const data = await loadNodes(); if (alive) { setSnapshot(data); setFailed(false); } }
      catch { if (alive) setFailed(true); }
      finally { busy = false; }
    };
    void load();
    const timer = setInterval(load, 10000);
    window.addEventListener('node-monitor-preference', load);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('node-monitor-preference', load); };
  }, []);
  if (!snapshot || snapshot.muted) return null;
  const down = snapshot.nodes.filter(node => node.enabled && node.status === 'down');
  const stale = snapshot.nodes.some(node => nodeIsStale(node, snapshot));
  if (!down.length && !stale && !failed) return null;
  const names = down.slice(0, 4).map(node => node.name.replace(/\.smoke\.team$/, '')).join(', ');
  return <div className={styles.alert} role="alert" aria-live="polite">
    <strong>{down.length ? `Ноды недоступны (${down.length}): ${names}${down.length > 4 ? ` и ещё ${down.length - 4}` : ''}` : 'Мониторинг нод: данные не обновляются'}</strong>
    <Link to="/node-monitor">Открыть мониторинг</Link>
  </div>;
}
